<template>
  <div class="content">
    <div class="top">
      <div class="elec_speed">
        <el-steps :active="2" finish-status="success" simple>
          <el-step :title=motor></el-step>
          <el-step :title=ratio></el-step>
          <el-step :title=size></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <div class="elec_select">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple elec_select_left">
            <!-- <img src="@/assets/machine.png" alt=""> -->
            <img :src=picUrl alt="" class="reducerPic">
            <div class="text">
              <h4>{{$t('message.manufacturer')}} <span>{{ motor_factory }}</span></h4>
              <h4>{{$t('message.model')}} <span>{{ motor_type }}</span></h4>
              <h4>{{$t('message.series')}} <span>{{ reducer_series_name }}</span></h4>
            </div>
          </div>
        </el-col>

        <!-- 多级选择菜单 -->
        <el-col :span="12">
          <div class="grid-content bg-purple-light elec_select_right">
            <div class="select_box">
              <h3>{{$t('message.selectSizeInfo')}} <span style="color:red;font-size:12px;">{{$t('message.info12')}}</span></h3>
              <div class="radio_box">
                <!-- <el-radio v-model="size_radio" label="1" border> 5C90 </el-radio>
                <el-radio v-model="size_radio" label="2" border> 5C90 </el-radio> -->
                <el-cascader filterable
                  ref="cascaderAddr"
                  :options="options"
                  v-model="selectedOptions"
                  :props="optionProps"
                  :show-all-levels="false"
                  @change="handleChange">
                </el-cascader>
              </div>
              <span class="renturnPrePage" @click="renturnPrePage">{{$t('message.Return')}}</span>
              <span class="toNextPage" @click="toNextPage">{{$t('message.Next')}}</span>
              <div style="margin-top:15px;color:red;"><p>{{$t('message.info13')}}</p></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 下载规格书·外形图 & 资料页-->
    <div class="elec_detail">
      <el-row>
        <!-- <el-col :span="24">
          <h2>下载规格书·外形图</h2>
        </el-col>
        <el-col :span="24" style="padding-top:30px;font-weight:bold;">
          <el-col :span="8">产品规格表</el-col>
          <el-col :span="8">外形图</el-col>
          <el-col :span="8">CAD数据(2D-3D)</el-col>
        </el-col>
        <el-col :span="24" style="padding-top:30px;">
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
              <el-button size="mini">IGS下载</el-button>
              <el-button size="mini">STP下载</el-button>
            </div>
          </el-col>
        </el-col>
        <el-col :span="24" style="padding-top:30px;">
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（不附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（不附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="downloadSpec">
              <h4>VRS-060C-5-K3-14BE9（不附带输出键）</h4>
              <el-button class="button_first" size="mini">PDF下载</el-button>
              <el-button size="mini">IGS下载</el-button>
              <el-button size="mini">STP下载</el-button>
            </div>
          </el-col>
        </el-col> -->
        <el-col :span="24" style="padding-top:20px;">
          <h2>{{$t('message.Information')}}</h2>
          <el-collapse v-model="activeNames" style="background:#FCFCFC;">
            <el-collapse-item :title=DecelerationDimensionDetails name="1">
              <el-row class="card_box">
                <el-table :data="tableData" border style="width: 100%" :header-cell-style="{background:'#F4F4F4'}">
                  <el-table-column
                    prop="reducer_size"
                    :label=GearboxModel
                    width="120"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="usable"
                    :label=Judge
                    align="center"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="reducer_level"
                    :label=Stage
                    align="center"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="remarks"
                    align="center"
                    :label=Note>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import {
    getlistbyseriesandmotor,
    getPicUrl
  } from '@/store/electric_motor'
  export default {
    name: 'SelectedDeceleration',
    data() {
      return {
        size_radio:'1',
        activeNames: ['1'],
        options: [],
        selectedOptions: [],
        optionProps: {
          value: 'value',
          label: 'label',
        },
        tableData: [],
        machineSize: {},
        motor_factory:'',
        motor_type:'',
        reducer_series_name:'',
        motor : this.$t('message.motor'),
        ratio : this.$t('message.ratio'),
        size : this.$t('message.size'),
        complete : this.$t('message.complete'),
        DecelerationDimensionDetails : this.$t('message.DecelerationDimensionDetails'),
        GearboxModel : this.$t('message.GearboxModel'),
        Judge : this.$t('message.Judge'),
        Stage : this.$t('message.Stage'),
        Note : this.$t('message.Note'),
        picUrl:''
      };
    },
    props:{
      param_1:Object,
      required: true
    },
    beforeUpdate(){
      getPicUrl(this.param_1.reducer_series_name).then((response) => {
        if (response.success === true) {
          this.picUrl = response.data[0].outlook_picture
        }
      })
    },
    methods: {
      renturnPrePage:function(){
        this.$emit("listenPageChange","to_DecelerationPage");
      },
      toNextPage:function(){
        if(this.machineSize.name){
          this.$emit("listenPageChange","to_CompletedPage");
          this.$emit("listenParam_1",this.machineSize);
        }else{
          this.$message({
            message: '请选择减速机型号!',
            type: 'warning'
          });
        }
      },
      // 通过前面参数获取可用的减速机型号
      _getlistbyseriesandmotor:function(){
        getlistbyseriesandmotor(this.param_1).then((response) => {
          this.options = [];
          this.motor_factory = this.param_1.motor_factory;
          this.motor_type = this.param_1.motor_type;
          this.reducer_series_name = this.param_1.reducer_series_name;
          if (response.success === true) {
            const data_array = response.data.list
            // 获取合适的减速机型号
            for(var i=0;i < data_array.length;i++){
              if(data_array[i].usable === '1'){
                this.options.push({
                  'label':data_array[i].reducer_size,
                  'value':data_array[i].id
                });
              }
            }
            if(this.options.length === 0){
              this.$message({
                message: '没有合适的减速机型号供选择!',
                type: 'warning'
              });
            }
            var lang = localStorage.getItem('lang');
            if(lang == 'cn'){
              for(var i=0 ; i < response.data.list.length ; i++){
                if(response.data.list[i].usable === "0"){
                  response.data.list[i].usable = '不可用'
                }else if(response.data.list[i].usable === "1"){
                  response.data.list[i].usable = '可用'
                }
              }
            }else if(lang == 'en'){
              for(var i=0 ; i < response.data.list.length ; i++){
                if(response.data.list[i].usable === "0"){
                  response.data.list[i].usable = 'NG'
                }else if(response.data.list[i].usable === "1"){
                  response.data.list[i].usable = 'OK'
                }
              }
            }
            // 获取减速机使用详情表格数据
            this.tableData = response.data.list;
          }
        })
      },
      handleChange(){
        const cascaderAddr_name = this.$refs['cascaderAddr'].currentLabels;
        this.machineSize.name = cascaderAddr_name[0];
      },
    }
  };
</script>
<style scoped>
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
  }
  .top {
    height:100px;
    border-bottom:1px solid #EBEBEB;
  }
  .elec_speed {
    width:80%;
    margin:0 auto;
    padding-top:25px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../static/step.png') no-repeat #F5F7FA;
    background-size:25% 100%;
    background-position-x:73%;
  }
  .elec_select_left img{
    width: 35%;
    height: 35%;
    display: block;
    margin: 0 auto;
    padding-top: 70px;
  }
  .elec_select_left .text{
    text-align: left;
    font-weight: bold;
    margin-left: 270px;
  }
  .elec_select_left .text h4 {
    padding-top:5px;
  }
  .elec_select_left .text h4 span{
    padding-left:30px;
  }
  .el-cascader-menus el-popper{
    z-index: 2010;
    position: absolute;
    top: 284px;
    left: 952px;
  }
  .select_box {
    padding-left:10px;
    padding-top:80px;
  }
  .toNextPage {
    width:97px;
    height:42px;
    cursor: pointer;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    display: inline-block;
    margin-left:15px;
  }
  .renturnPrePage {
    width:97px;
    height:42px;
    cursor: pointer;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    display: inline-block;
  }
  .elec_detail {
    width:80%;
    margin:0 auto;
    margin-top:70px;
  }
  .detail_img {
    width:150px;
    height:150px;
  }
  .detail_img_box {
    width:70%;
    margin:0 auto;
    padding-top:20px;
  }
  .radio_box {
    margin-top:50px;
  }
  .radio_box .el-radio {
    width:140px;
    height:70px;
    height:70px;
  }
  .downloadSpec {
    width:350px;
    height:115px;
    background-color: #F4F4F4;
    border-radius: 10px;
  }
  .downloadSpec h4 {
    text-align: center;
    padding-top:30px;
    font-weight: normal;
  }
  .downloadSpec .el-button {
    margin-top:15px;
  }
  .downloadSpec .button_first {
    margin-left:30px;
  }

  .card_box {
    margin-top:20px;
    width:90%;
    margin:0 auto;
    height:100%;
  }
  .card_box_column {
    border-bottom:1px solid #ccc;
    padding-top:20px;
    height:100px;
    text-align: center;
  }
  .card_box_column .item {
    line-height: 70px;
  }
  .card_box_column .item_2 {
    width:250px;
    margin-left:50px;
  }
  .card_box_column_top {
    border-bottom:1px solid #ccc;
    height:70px;
    line-height: 70px;
    text-align: center;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .card_box_column .item_2 {
      width:180px;
      margin-left:30px;
    }
    .card_box_column .item {
      line-height: 30px;
      padding-top:30px;
    }
    .elec_select_left .text{
      text-align: left;
      font-weight: bold;
      margin-left: 180px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ElectricMachine/SelectedMachineSize.vue